
export default function Services() {
  const navigateToPage = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const services = [
    {
      icon: 'ri-flask-line',
      title: 'Chemical Formulation',
      description: 'Custom chemical solutions designed to meet specific project requirements and performance standards.',
      features: ['Custom Formulations', 'Performance Testing', 'Quality Assurance', 'Technical Support']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Surface Protection',
      description: 'Advanced protective coatings and treatments for concrete, steel, and other construction materials.',
      features: ['Corrosion Protection', 'Weather Resistance', 'Chemical Resistance', 'Long-term Durability']
    },
    {
      icon: 'ri-tools-line',
      title: 'Application Services',
      description: 'Professional application and installation services by certified technicians and specialists.',
      features: ['Expert Application', 'Quality Control', 'Safety Compliance', 'Project Management']
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Technical Consulting',
      description: 'Expert consultation and technical support for complex construction chemical challenges.',
      features: ['Problem Analysis', 'Solution Design', 'Implementation Support', 'Ongoing Maintenance']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive chemical solutions and services for all your construction and industrial needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto"
                style={{ backgroundColor: '#7E887E' }}
              >
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 text-center">
                {service.description}
              </p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => navigateToPage('/services')}
            className="px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
            style={{ backgroundColor: '#7E887E' }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
          >
            View All Services
          </button>
        </div>
      </div>
    </section>
  );
}